
/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';
// import { Badge } from '@vds/badges';
import { Tabs, Tab } from '@vds/tabs';
import { Line } from '@vds/lines';
import { TextLink } from '@vds/buttons';

import ShippingPinModal from '../../../common/Modal/shippingPinVerificationModal';
import {
  getSession,
  isMobile as isMobileDevice,
  isDesktop,
  isTablet,
  isWHW,
  isShippingTabEnabled,
  isWHWPhase2Flag,
  isWHWP2,
} from '../../../common/Helpers/index';
import { eventDispatcher } from '../../../common/Tagging/index';
import { saveItemToStore } from '../../../../utils/sessionStorage';
import logger from '../../../common/ErrorBoundary/logger_new';
import { store } from '../../../../configureStore';
import { getThrottleKeys } from '../../../common/Helpers/taggingHelper';
import { PRICE_ZERO, VCS, VAR } from '../../../../pages/ShippingInfo/Constants';
import { ShippingDetailsWrapper, ShippingOptionsGroup } from './shippingStyles';
import { Margin, StyledWrapper } from '../../../common/styles';
import { Row } from '../../../common/FWAContainer';
import Button from '../../../common/Button';
import Heading from '../../../common/Heading/head';
import { getFullStoreAddress } from '../../../common/addressUtils';
import { isIndirectStoresEnabled } from '../ShippingInfoHelper';

const BasicWrapper = styled.div`
  margin: ${({ margin }) => margin.map((value) => `${value}px`).join(' ')};
`;

const TabsWrapper = styled.div`
  margin: ${({ margin }) => margin.map((value) => `${value}px`).join(' ')};
`;

const ButtonWrapper = styled.button`
  text-underline-offset: 5px;
`;

// const BadgeWrapper = styled.div`
//   position: absolute;
//   right: -65px;
//   top: 0;
// `;

const ExpressTab = styled.div`
  position: relative;
`;

const ExpressWrapper = styled.div``;

const NoExpressStoreWrapper = styled.div`
  margin-bottom: 50px;
`;

export default class ShippingOptions extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      toggleTileTop: false,
      termsAndConditionsModalVisible: false,
      selectedSlotId: null,
      selectedOption: props.defaultSelectedSlot?.shippingOptionId,
      selectionBeforeISPU: null,
      // eslint-disable-next-line react/prop-types
      isThrottled: false,
      isHideIspuThrottleValue: false,
      isFastestBadge: false,
      expressPickupList: [],
      isIspuDisplay: false,
    };
    this.shippingOptionsRef = [];
    this.seeDetailRef = React.createRef();
    this.ispuListener = this.ispuListener.bind(this);
  }

  componentDidMount() {
    // MAKING ISPU GET STORES CALL
    // eslint-disable-next-line react/prop-types
    const shippingThrottleKeys = getThrottleKeys(this.props?.cradleResponseDetails, 'FWA_Shipping');
    if (this.props?.cradleResponseDetails) {
      const hideIspuOption = this.props?.cradleResponseDetails?.includes('FWA_ISPU_T_Option');
      const isThrottledVallue = this.props?.cradleResponseDetails?.includes('FWA_Express_T_Pickup') || getSession('shippingTabRedesign') === 'Y';
      this.setState({ isThrottled: isThrottledVallue, isHideIspuThrottleValue: hideIspuOption });
    }
    const { notifyMessage, isShippingOptionAvailable, shippingDescription } = this.props;
    if (notifyMessage && this.props?.shippingOption?.notifyMessage) {
      this.props.shippingOption.notifyMessage = notifyMessage;
    }
    const deliveryDate = new Date(this.props.shippingOption?.estimatedDeliveryDate);
    const deliveryDate1 = `${deliveryDate.getMonth() + 1}/${deliveryDate.getDate()}/${deliveryDate.getFullYear()}`;
    saveItemToStore('deliveryDate', deliveryDate1);
    let homePhoneAdded = false;
    // console.log("THROTTLE", shippingThrottleKeys);
    let var220 = 'FWA_Express_C_Pickup';
    //  const var221 ='ep n'
    if (isShippingTabEnabled()) {
      var220 = 'FWA_Express_T_Pickup';
      // var221 = 'ep y'
    }
    // console.log("USEEFFECT");
    eventDispatcher('sendData', {
      name: '',
      svars: {
        // evar221: 'AP Toggle Y',
        evar220: var220,
        evar221: shippingThrottleKeys.join('|'),
      },
    });
    const homePhoneResponse = this.props.cartDetails?.dueTodayList?.filter((item) => item.isHomePhone !== undefined && item.isHomePhone === true);
    if (homePhoneResponse && homePhoneResponse.length > 0) {
      homePhoneAdded = true;
    }
    if (
      !isShippingOptionAvailable &&
      !shippingDescription &&
      this.props.shippingInfoDetails?.lines?.[0]?.shippingOptions &&
      !isEmpty(this.props.shippingInfoDetails?.lines?.[0]?.shippingOptions) &&
      !(isWHW() || isWHWP2())
    ) {
      this.props.buildShippingOptionsInput(this.props.shippingOption, null, null, homePhoneAdded);
    } else if (
      (getSession('isResumeOrder') === 'Y' ||
        getSession('emailFlow') === 'Y' ||
        getSession('ExistingCase') === 'true' ||
        getSession('ExistingCase') === true) &&
      !isShippingOptionAvailable &&
      !shippingDescription &&
      !(isWHW() || isWHWP2())
    ) {
      if (this.props?.shippingOption) {
        this.props.buildShippingOptionsInput(this.props?.shippingOption, null, null, homePhoneAdded);
      }
    } else if (isWHW() || isWHWP2()) {
      this.props.buildShippingOptionsInput(this.props.shippingOption, null, null, homePhoneAdded);
    }
    if (
      this.props.shippingInfoDetails &&
      this.props.shippingInfoDetails?.lines &&
      this.props.shippingInfoDetails?.lines?.[0] &&
      this.props.shippingInfoDetails?.lines?.[0]?.shippingOptions &&
      isEmpty(this.props.shippingInfoDetails?.lines?.[0]?.shippingOptions)
    ) {
      const errorLog = {
        json: true,
        eventType: 'BLOCKER',
        message: 'GENERIC_ERROR_PAGE',
        note: 'from shipping component',
        // networkError: {
        //   error: apiResponse,
        //   response: apiResponse.data.errors || null,
        // },
      };
      logger(errorLog);
    }
    const ispuOptionBoxQuery = document.getElementById('ispuOptionBox');
    if (ispuOptionBoxQuery) {
      ispuOptionBoxQuery.addEventListener('click', this.ispuListener);
    }
  }

  /** deprecated  */
  // componentWillReceiveProps(nextProps) {
  //   if (this.props?.shippingOption?.shippingOptionId != nextProps.shippingOption?.shippingOptionId) {
  //     this.setState({ selectedSlotId: nextProps.shippingOption?.shippingOptionId || nextProps.defaultSelectedSlot });
  //   }
  // }

  componentDidUpdate(prevProps) {
    // debugger;
    const { ispuStoreInfo } = this.props.shippingInfoState;
    const existingExpress = this.state.expressPickupList;
    const found = existingExpress && existingExpress.some((el) => el.storeName === ispuStoreInfo?.storeName);
    if (this.state.isThrottled && ispuStoreInfo && prevProps?.shippingInfoState?.ispuStoreInfo?.storeName !== ispuStoreInfo?.storeName) {
      if (!found) {
        existingExpress.length = 0;
        existingExpress.unshift(ispuStoreInfo);
      }
      this.props.selectedShippingOptionValue(ispuStoreInfo.id);
      this.props.saveSelectedOption(ispuStoreInfo);
      this.setState({ selectedSlotId: ispuStoreInfo.id });
      this.setState({ expressPickupList: existingExpress });
    }
    if (
      (!Object.keys(this.props?.selectedShippingOption).length ||
        (Object.keys(this.props.selectedShippingOption).length &&
          Object.prototype.hasOwnProperty.call(this.props.selectedShippingOption, 'name') &&
          Object.prototype.hasOwnProperty.call(this.props.selectedShippingOption, 'twoDayShipping'))) &&
      prevProps.storeLists !== this.props.storeLists
    ) {
      this.setState({ expressPickupList: this.getNearExpressStores() });
    } else {
      this.setSelectedExpressTile();
    }
    if (
      (prevProps.openISPUModal && !this.props.openISPUModal && !this.props.shippingInfoState?.ispuStoreInfo && !isWHWPhase2Flag()) ||
      (isWHWPhase2Flag() && this.props.selectOtherOption)
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState((prevState) => ({ selectedSlotId: prevState.selectionBeforeISPU || this.props.defaultSelectedSlot?.shippingOptionId }));
      if (isWHWPhase2Flag() && this.props.selectOtherOption) {
        store.dispatch({ type: 'SELECTED_OTHER_SHIPPING' });
      }
    }
    if (!this.state.selectedSlotId) {
      // eslint-disable-next-line react/no-did-update-set-state
      const currentShippingId = this.getCurrentShippingCode(this.props);
      this.setState({ selectedSlotId: currentShippingId });
      if (isShippingTabEnabled()) {
        if (currentShippingId?.includes('SHP')) {
          this.props.changeDivToPickUp(false);
        } else if (currentShippingId?.includes('ISPU')) {
          this.props.changeDivToPickUp(true);
        }
      } else {
        this.props.changeDivToPickUp(false);
      }
    }
    if (this.state?.selectedSlotId === 'ISPU' && !this.state.isISPUSelectedValue) {
      this.props.selectedShippingOptionValue('ISPU');
      this.setState({ isISPUSelectedValue: true });
    }
  }

  componentWillUnmount() {
    const ispuOptionBoxQuery = document.getElementById('ispuOptionBox');
    if (ispuOptionBoxQuery) {
      ispuOptionBoxQuery.removeEventListener('click', this.ispuListener);
    }
  }

  setSelectedExpressTile() {
    const selectedShippingOption = this.props?.selectedShippingOption;
    const existingExpress = this.state.expressPickupList;
    if (
      Object.keys(selectedShippingOption).length &&
      !Object.prototype.hasOwnProperty.call(this.props.selectedShippingOption, 'name') &&
      !Object.prototype.hasOwnProperty.call(this.props.selectedShippingOption, 'twoDayShipping')
    ) {
      const found = existingExpress && existingExpress.some((el) => el.storeName === selectedShippingOption?.storeName);
      if (!found) {
        existingExpress.length = 0;
        existingExpress.unshift(selectedShippingOption);
        this.setState({ expressPickupList: existingExpress });
      }
      if (existingExpress && existingExpress.length && existingExpress[0].distance < this.props.milesValue) {
        this.setState({ isFastestBadge: true });
      } else {
        this.setState({ isFastestBadge: false });
      }
      this.setState({ selectedSlotId: selectedShippingOption.id });
    }
  }

  ispuListener = (e) => {
    if (this.state?.selectedSlotId === 'ISPU') {
      e.target.value = 'ISPU';
      this.onSelectShippingType(e, this.props?.notifyMessage);
    }
  };

  onSelectShippingType = (e, notifyMessage) => {
    // e.target.setAttribute('data-track', 'free in-store pickup');
    try {
      if (e) {
        e.preventDefault();
      }
      const [lineObject] = this.props.shippingInfoDetails?.lines;
      const selectedShipping = lineObject.shippingOptions?.find((optionRef) => optionRef.shippingOptionId === e.target?.value);
      this.props.selectedShippingOptionValue(selectedShipping.shippingOptionId);
      if (notifyMessage) {
        selectedShipping.notifyMessage = notifyMessage;
      }
      this.props.saveSelectedOption(selectedShipping);
      if (selectedShipping.shippingOptionId !== 'ISPU') {
        this.setState({
          selectedSlotId: selectedShipping.shippingOptionId,
        });
      } else {
        store.dispatch({ type: 'SET_ISPU_MODAL' });
        this.setState((prevState) => ({
          selectionBeforeISPU: prevState.selectedSlotId,
          selectedSlotId: selectedShipping.shippingOptionId,
        }));
        const obj = {
          name: 'openIspuModal',
          selector: 'openIspuModalID',
        };
        eventDispatcher('openView', obj);
      }
      if (selectedShipping.shippingOptionId !== 'SDD_SAMEDAY' && selectedShipping.shippingOptionId !== 'ISPU') {
        const deliveryDate = new Date(selectedShipping.estimatedDeliveryDate);
        const deliveryDate1 = `${deliveryDate.getMonth() + 1}/${deliveryDate.getDate()}/${deliveryDate.getFullYear()}`;
        saveItemToStore('deliveryDate', deliveryDate1);
        let homePhoneAdded = false;
        const homePhoneResponse = this.props.cartDetails?.dueTodayList?.filter((item) => item.isHomePhone !== undefined && item.isHomePhone === true);
        if (!(isWHW() || isWHWP2()) && homePhoneResponse && homePhoneResponse.length > 0) {
          homePhoneAdded = true;
        }
        this.props.buildShippingOptionsInput(selectedShipping, null, null, homePhoneAdded);
      }
      if (selectedShipping.shippingOptionId === 'SDD_SAMEDAY') {
        const deliveryDate = new Date(selectedShipping.estimatedDeliveryDate);
        const deliveryDate1 = `${deliveryDate.getMonth() + 1}/${deliveryDate.getDate()}/${deliveryDate.getFullYear()}`;
        saveItemToStore('deliveryDate', deliveryDate1);
        this.props.sddSlotsData(this.props.shippingAddress, this.props.cartDetails.dueTodayList);
      }
    } catch (error) {
      // TODO notify/log
      console.log(error);
    }
  };

  onSelectExpressType = (e, notifyMessage) => {
    try {
      if (e) {
        e.preventDefault();
      }
      const selectedShipping = this.props?.storeLists?.find((optionRef) => optionRef.id === e.target?.value);
      const cartWHWPlusData = this.props?.cartDetails?.dueMonthlyList.filter((obj) => obj.itemType === 'WHWPLUS');
      if (selectedShipping && isWHWPhase2Flag() && cartWHWPlusData.length > 0) {
        // store.dispatch({type: 'EXPRESS_STORE_SELECTED'});
        store.dispatch({ type: 'EXPRESS_STORE_SELECTED', response: selectedShipping });
      }
      if (!isWHWPhase2Flag() || (isWHWPhase2Flag() && cartWHWPlusData.length === 0)) {
        this.props.updateISPUShippingOption({
          locationCode: selectedShipping ? selectedShipping.netaceLocationCode : '',
          cradleResponseDetails: this.props.cradleResponseDetails,
          storeInfo: {
            storeName: selectedShipping && selectedShipping.storeName,
            storeAddress: selectedShipping && selectedShipping.storeAddress,
            zipCode: selectedShipping && selectedShipping.zipCode,
            id: selectedShipping && selectedShipping.id,
            distance: selectedShipping && selectedShipping.distance,
          },
        });
        this.props.selectedShippingOptionValue(selectedShipping.id);
        if (notifyMessage) {
          selectedShipping.notifyMessage = notifyMessage;
        }
        if (!isWHWPhase2Flag() || (isWHWPhase2Flag() && cartWHWPlusData.length === 0)) {
          this.props.updateISPUShippingOption({
            locationCode: selectedShipping ? selectedShipping.netaceLocationCode : '',
            cradleResponseDetails: this.props.cradleResponseDetails,
            storeInfo: {
              storeName: selectedShipping && selectedShipping.storeName,
              storeAddress: selectedShipping && selectedShipping.storeAddress,
              zipCode: selectedShipping && selectedShipping.zipCode,
              id: selectedShipping && selectedShipping.id,
              distance: selectedShipping && selectedShipping.distance,
            },
          });
          this.props.selectedShippingOptionValue(selectedShipping.id);
          if (notifyMessage) {
            selectedShipping.notifyMessage = notifyMessage;
          }
          this.props.saveSelectedOption(selectedShipping);

          this.setState((prevState) => ({
            selectionBeforeISPU: prevState.selectedSlotId,
            selectedSlotId: selectedShipping.id,
          }));
          if (selectedShipping && isWHWPhase2Flag()) {
            // store.dispatch({type: 'EXPRESS_STORE_UPDATED'});
            store.dispatch({ type: 'REMOVE_WHWPLUS' });
          }
        }
      }
    } catch (error) {
      // TODO notify/log
      console.log(error);
    }
  };

  toggleShippingOptions = () => {
    this.setState((prevState) => ({ isIspuDisplay: !prevState.isIspuDisplay }));
  };

  showTermsAndConditionsModal = (e) => {
    e.preventDefault();
    this.setState({ termsAndConditionsModalVisible: true });
    const obj = {
      name: '5GTermsAndConditionsModal',
      selector: 'termsAndConditionsModalID',
    };
    eventDispatcher('openView', obj);
  };

  closeTermsAndConditionModal = (e) => {
    e.preventDefault();
    this.setState({ termsAndConditionsModalVisible: false });
  };

  changeStoreModal = () => {
    store.dispatch({ type: 'SET_ISPU_MODAL' });
    const obj = {
      name: 'openIspuModal',
      selector: 'openIspuModalID',
    };
    eventDispatcher('openView', obj);
  };

  modalChanged = (termsAndConditionsModalVisible) => {
    this.setState({ termsAndConditionsModalVisible });
    const obj = { detail: '5GTermsAndConditionsModal', selector: 'termsAndConditionsModalID' };
    eventDispatcher('closeView', obj);
  };

  // used to add element in refs.
  addToRefs = (el) => {
    this.shippingOptionsRef.push(el);
  };

  renderNearestStore = (item) => {
    if (item === true) {
      this.setState({ toggleTileTop: true });
      return true;
    }
    this.setState({ toggleTileTop: false });
    return false;
  };

  getOptionData = (shippingData, id) => {
    const { ispuStoreInfo } = this.props.shippingInfoState;
    const isISPU = shippingData?.shippingOptionId === 'ISPU';
    const isISPUSelected = this.state.selectedSlotId === shippingData?.shippingOptionId && (ispuStoreInfo?.storeName || ispuStoreInfo?.storeAddress);
    const nonMobileWidth = isDesktop() ? '398px' : 'calc(calc(100% - 12px) / 2)';
    const commonProps = {
      width: isMobileDevice() ? '' : nonMobileWidth,
      ariaLabel: this.getAriaLabel(shippingData, id),
      className: 'shippingOptionWrapper',
      value: shippingData?.shippingOptionId,
    };
    if (isISPU) {
      /** content overflows in Tablet with <br> as the VDS Box height is not fluid */
      let nearestStockedStore = [];
      const storesLst = this.props?.storeLists;
      let outStores = [];
      if (storesLst && storesLst.length > 0) {
        storesLst.forEach((storeAvailable) => {
          const quanAvl = storeAvailable?.items?.item?.every((item) => item.quantity > 0);
          if (quanAvl) {
            return outStores.push(storeAvailable);
          }
        });
        outStores = outStores?.sort((a, b) => a.distance - b.distance);
        nearestStockedStore = outStores?.[0]?.distance < this.props?.milesValue;
      }
      const closestInstockStoreDistance = outStores?.[0]?.distance;
      let stockedStore = '';
      if (this.renderNearestStore(nearestStockedStore)) {
        stockedStore = `<span className= 'vdsTextGray fontsize_14'>${this.props?.inStockText}</span>`;
      } else {
        stockedStore = '';
      }
      const description = isTablet() ? shippingData?.shippingDescription : shippingData?.shippingDescriptionVDSUpgrade;
      return {
        ...commonProps,
        id: 'ispuOptionBox',
        text: shippingData?.shortDescription,
        'data-track': shippingData?.shortDescription,
        subtext: parse(
          isISPUSelected
            ? `${ispuStoreInfo?.storeName}<br>${ispuStoreInfo?.storeAddress}`
            : (this.renderNearestStore(nearestStockedStore)
                ? `<div className='fontsize_14'>Within ${closestInstockStoreDistance} miles</div>${stockedStore}`
                : description) || '',
        ),
        subtextRight: Number.isNaN(shippingData?.shippingCost) ? PRICE_ZERO : `$${parseFloat(shippingData?.shippingCost).toFixed(2)}`,
      };
    }
    return {
      ...commonProps,
      text: shippingData?.shippingDescription,
      subtext: shippingData?.estimatedDeliveryDateText,
      subtextRight: Number.isNaN(shippingData?.shippingCost) ? PRICE_ZERO : `$${parseFloat(shippingData?.shippingCost).toFixed(2)}`,
    };
  };

  // eslint-disable-next-line no-unused-vars
  getExpresTitle = (isFastest) => <ExpressTab>Express Pickup </ExpressTab>;

  getShippingOptionData = (shippingData, id) => {
    const nonMobileWidth = isDesktop() ? '398px' : 'calc(calc(100% - 12px) / 2)';
    const commonProps = {
      width: isMobileDevice() ? '' : nonMobileWidth,
      ariaLabel: this.getAriaLabel(shippingData, id),
      className: 'shippingOptionWrapper',
      value: shippingData?.shippingOptionId,
    };
    return {
      ...commonProps,
      text: shippingData?.shippingDescription,
      subtext: shippingData?.estimatedDeliveryDateText,
      subtextRight: Number.isNaN(shippingData?.shippingCost) ? PRICE_ZERO : `$${parseFloat(shippingData?.shippingCost).toFixed(2)}`,
    };
  };

  getExpressOptionData = (shippingData) => {
    const nonMobileWidth = isDesktop() ? '398px' : 'calc(calc(100% - 12px) / 2)';
    const commonProps = {
      width: isMobileDevice() ? '' : nonMobileWidth,
      ariaLabel: this.getExpressAriaLabel(shippingData),
      className: 'expressOptionWrapper',
      value: shippingData?.id,
    };
    const storeAddress = shippingData?.storeAddress
      ? `${shippingData?.storeAddress}, ${shippingData?.zipcode}`
      : `${shippingData?.address1}, ${shippingData?.city}, ${shippingData?.state}, ${shippingData?.zipCode}`;
    if (isIndirectStoresEnabled()) {
      const storeType = shippingData?.direct === 'Y' && shippingData?.businessName?.toLowerCase() === 'verizon wireless' ? VCS : VAR;
      return {
        ...commonProps,
        text: shippingData?.storeName,
        subtext: parse(`${storeType}<br>${storeAddress}<br>${shippingData?.distance} miles`),
        subtextRight: Number.isNaN(shippingData?.shippingCost) ? PRICE_ZERO : `$00`,
      };
    }
    return {
      ...commonProps,
      text: shippingData?.storeName,
      subtext: parse(`${storeAddress}<br>${shippingData.distance} miles`),
      subtextRight: Number.isNaN(shippingData?.shippingCost) ? PRICE_ZERO : `$00`,
    };
  };

  getNearExpressStores = () => {
    let fastestBadge;
    const storesLst = this.props?.storeLists;
    let outStores = [];
    if (storesLst && storesLst.length > 0) {
      storesLst.forEach((storeAvailable) => {
        const quanAvl = storeAvailable?.items?.item?.every((item) => item.quantity > 0);
        if (quanAvl) {
          return outStores.push(storeAvailable);
        }
      });
      if (isIndirectStoresEnabled()) {
        const dStore = outStores?.filter((i) => i.direct === 'Y')?.sort((a, b) => a.distance - b.distance);
        const iStore = outStores?.filter((i) => i.direct === 'N' && i.distance < this.props?.milesValue)?.sort((a, b) => a.distance - b.distance);
        outStores = [...dStore, ...iStore]?.splice(0, 2);
      } else {
        outStores = outStores?.sort((a, b) => a.distance - b.distance)?.splice(0, 2);
      }
      fastestBadge = outStores?.[0]?.distance < this.props?.milesValue;
      this.setState({ isFastestBadge: fastestBadge });
      return outStores;
    }
    return [];
  };

  /** Legacy code */
  getAriaLabel = (shipping, id) =>
    `${shipping?.name} ${shipping?.shippingOptionId !== 'ISPU' ? shipping?.description : shipping?.shippingDescription} $${shipping?.shippingCost} ${
      navigator.userAgent?.indexOf('Mac OS X') !== -1
        ? `${id + 1} of ${this.props?.shippingInfoDetails?.lines?.length && this.props.shippingInfoDetails.lines[0]?.shippingOptions?.length}`
        : ''
    } ${
      navigator.userAgent?.indexOf('Mac OS X') !== -1 ? (this.state?.selectedOption === shipping?.shippingOptionId ? '' : 'not selected') : ''
    }`?.replace('. Signature required.', '');

  // static getDerivedStateFromProps(props) {
  //   const newState = { selectedSlotId: ShippingOptions.getCurrentShippingCode(props) };
  //   return newState;
  // }
  /** To be removed after container refactoring */
  getCurrentShippingCode = (props) => {
    if (props.defaultSelectedSlot) {
      return typeof props.defaultSelectedSlot === 'object' ? props.defaultSelectedSlot.shippingOptionId : props.defaultSelectedSlot;
    }
    return null;
  };

  isStoreAvailable = () => {
    this.setState({ isFastestBadge: false });
    return 'Select a different zip code';
  };

  changePageBottomDivToPickup = (index) => {
    if (index === 1) {
      const shippingThrottleKeys = getThrottleKeys(this.props?.cradleResponseDetails, 'FWA_Shipping');
      const var220 = 'FWA_Express_T_Pickup';
      eventDispatcher('sendData', {
        name: '',
        svars: {
          // evar221: 'AP Toggle Y',
          evar220: var220,
          evar221: shippingThrottleKeys.join('|'),
          evar27: 'express pickup',
        },
      });
      this.props.changeDivToPickUp(true);
    } else {
      this.props.changeDivToPickUp(false);
    }
  };

  getExpressAriaLabel = (shipping) => {
    const storeAddress = shipping.storeAddress ? `${shipping.storeAddress}, ${shipping.zipcode}` : getFullStoreAddress(shipping);
    return `${shipping?.storeName}, ${storeAddress}, ${shipping.distance} miles, $00`;
  };

  // noStoreTile = () => {
  //   const nonMobileWidth = isDesktop() ? '398px' : 'calc(calc(100% - 12px) / 2)';
  //   return (
  //     <RadioBox
  //       disabled
  //       outOfStock
  //       text="Free in-store pickup"
  //       subtext={parse('<br>No store close to your service address')}
  //       subtextRight="$0.00"
  //       orientation="vertical"
  //       width={isMobileDevice() ? '' : nonMobileWidth}
  //     />
  //   );
  // };

  render() {
    const ispuSelected =
      this.state?.selectedSlotId === 'ISPU' ||
      this.props?.cartDetails?.shippingDetails?.[0]?.shippingDescription === 'In-Store Pick Up' ||
      this.props?.selectShippingData?.[0]?.selectedOptionCode === 'ISPU';
    // console.log('LOG', this.props.shippingInfoState?.ispuStoreInfo);
    const { isThrottled } = this.state;
    const isMobile = isMobileDevice();
    const shippingDetails = [];
    let ispuObj = '';
    let sddObj = '';

    const shippingOptions =
      this.props.shippingInfoDetails &&
      this.props.shippingInfoDetails.lines &&
      this.props.shippingInfoDetails.lines[0] &&
      this.props?.shippingInfoDetails?.lines?.[0]?.shippingOptions;

    if (shippingOptions) {
      this.props.shippingInfoDetails.lines[0].shippingOptions.map((shipping) => shippingDetails.push(shipping));
    }
    const ispuEligible = this.props?.shippingInfoDetails?.lines?.[0]?.shippingOptions?.length
      ? this.props.shippingInfoDetails.lines[0].shippingOptions.find((i) => i.shippingOptionId === 'ISPU')
      : false;

    let final = shippingDetails;
    const expressList = this.state.expressPickupList;
    const showIspu = this.state.isHideIspuThrottleValue ? undefined : shippingDetails.find((i) => i.shippingOptionId === 'ISPU');
    const showSdd = shippingDetails.find((i) => i.shippingOptionId === 'SDD_SAMEDAY');
    if (showSdd !== undefined) {
      sddObj = shippingDetails.filter((i) => i.shippingOptionId === 'SDD_SAMEDAY');
      final = shippingDetails.filter((i) => i.shippingOptionId !== 'SDD_SAMEDAY');
      final.push(sddObj[0]);
    }  
    if ((this.state.isIspuDisplay || ispuSelected) && showIspu !== undefined && !isThrottled) {
      ispuObj = shippingDetails.filter((i) => i.shippingOptionId === 'ISPU');
      final = final.filter((i) => i.shippingOptionId !== 'ISPU');
      // if (this.state.toggleTileTop) {
      //   final.unshift(ispuObj[0]);
      // } else
      final.push(ispuObj[0]);
    } else {
      final = final.filter((i) => i.shippingOptionId !== 'ISPU');
    }

    const { notifyMessage } = this.props;
    const defaultValue = this.state.selectedSlotId;
    const optionsGroupProp = {
      orientation: isMobile ? 'vertical' : 'horizontal',
      childHeight: isDesktop() ? '100px' : '115px',
      value: this.state.selectedSlotId,
      defaultValue,
    };

    return (
      <>
        {isMobile && (
          <BasicWrapper margin={[20, 0]}>
            <Line type="secondary" surface="light" />
          </BasicWrapper>
        )}

        <Margin top={isMobile ? '23px' : '12px'} bottom="40px">
          <TextLink
            type="standAlone"
            surface="light"
            disabled={false}
            onClick={this.showTermsAndConditionsModal}
            analyticstrack="5G-open-Shipping-Options-Modal"
            aria-label="Learn more about shipping options"
            data-track='{"type": "link", "name": "learnAboutModal"}'
          >
            Learn more about shipping options
          </TextLink>
        </Margin>

        {!this.state.isThrottled ? (
          <StyledWrapper styles="margin-top: 20px">
            {shippingOptions && (
              <fieldset aria-label="shipping options" className="noPad noBorder">
                <div className="shippingSlots">
                  <ShippingOptionsGroup
                    key={defaultValue}
                    column={2}
                    {...optionsGroupProp}
                    data={final.map((shipping, id) => this.getOptionData(shipping, id))}
                    orientation="vertical"
                    onChange={(event) => this.onSelectShippingType(event, notifyMessage)}
                  />
                </div>
              </fieldset>
            )}
            {ispuEligible && !this.state.isHideIspuThrottleValue && !ispuSelected && (
              <Margin top={isMobile ? '23px' : '12px'}>
                <TextLink
                  type="standAlone"
                  surface="light"
                  disabled={false}
                  onClick={this.toggleShippingOptions}
                  analyticstrack="5G-open-Shipping-Options-Modal"
                  aria-label={this.state.isIspuDisplay ? 'Less Shipping options' : 'More Shipping options'}
                  data-track={this.state.isIspuDisplay ? 'shipping|Less options' : 'shipping|More options'}
                >
                  {this.state.isIspuDisplay ? 'Less options' : 'More options'}
                </TextLink>
              </Margin>
            )}

            <BasicWrapper margin={isMobile ? [41, 0, 31] : [33, 0, 40]}>
              <Line type="secondary" surface="light" />
            </BasicWrapper>
          </StyledWrapper>
        ) : (
          <TabsWrapper margin={isMobile ? [23, 0, 0] : [40, 0, 0]}>
            <Tabs orientation="horizontal" indicatorPosition="bottom" selectedIndex={this.props.showPickupInfoTab ? 1 : 0}>
              <Tab
                label="Shipping"
                onClick={() => {
                  this.changePageBottomDivToPickup(0);
                }}
              >
                <StyledWrapper styles="margin-top: 20px">
                  {shippingOptions && (
                    <fieldset aria-label="shipping options" className="noPad noBorder">
                      <div className="shippingSlots">
                        <ShippingOptionsGroup
                          key={defaultValue}
                          column={2}
                          {...optionsGroupProp}
                          data={final.map((shipping, id) => this.getShippingOptionData(shipping, id))}
                          orientation={this.state.toggleTileTop || isMobile ? 'vertical' : 'horizontal'}
                          onChange={(event) => this.onSelectShippingType(event, notifyMessage)}
                        />
                      </div>
                    </fieldset>
                  )}
                  <BasicWrapper margin={isMobile ? [23, 0, 0] : [12, 0, 0]} />
                  <BasicWrapper margin={isMobile ? [41, 0, 31] : [33, 0, 40]}>
                    <Line type="secondary" surface="light" />
                  </BasicWrapper>
                </StyledWrapper>
              </Tab>
              <Tab
                label={this.getExpresTitle(this.state.isFastestBadge)}
                onClick={() => {
                  this.changePageBottomDivToPickup(1);
                }}
              >
                {expressList && expressList.length ? (
                  <ExpressWrapper>
                    <Heading
                      heading="Select a store"
                      size="24"
                      className={(isWHW() || isWHWP2()) && !isMobile ? 'marginTop30 ' : ' '}
                      width={isMobile ? '341px' : ''}
                    />
                    <StyledWrapper>
                      {this.props.shippingInfoDetails &&
                        this.props.shippingInfoDetails.lines &&
                        this.props.shippingInfoDetails.lines[0] &&
                        this.props.shippingInfoDetails.lines[0].shippingOptions && (
                          <fieldset aria-label="express shipping options" className="noPad noBorder">
                            <ShippingOptionsGroup
                              key={defaultValue}
                              column={2}
                              {...optionsGroupProp}
                              data={expressList.map((shipping) => this.getExpressOptionData(shipping))}
                              orientation={this.state.toggleTileTop || isMobile ? 'vertical' : 'horizontal'}
                              onChange={(event) => this.onSelectExpressType(event, notifyMessage)}
                            />
                          </fieldset>
                        )}
                    </StyledWrapper>
                  </ExpressWrapper>
                ) : (
                  <NoExpressStoreWrapper>
                    <Heading
                      heading="Sorry, there are no stores near your service address that are available for in-store pickup."
                      size="16"
                      className={(isWHW() || isWHWP2()) && !isMobile ? 'marginTop30  marginBottom30 ' : ' '}
                      width={isMobile ? '341px' : ''}
                    />
                    {/* {this.noStoreTile()} */}
                  </NoExpressStoreWrapper>
                )}
                <BasicWrapper margin={isMobile ? [23, 0, 0] : [0, 0, 0]}>
                  <ButtonWrapper
                    type="button"
                    className="fontSize_4 letterSpacing_1 linkAlign link  marginTop12  marginBottom30 background_transparent displayInlineBlock borderSize_0 noPad"
                    onClick={this.changeStoreModal}
                    // eslint-disable-next-line react/no-unknown-property
                    analyticstrack="5G-open-Shipping-Options-Modal"
                    aria-label="Change store"
                    data-track='{"type": "link", "name": "changeStoreModal"}'
                  >
                    {expressList && expressList.length ? 'Change Store' : this.isStoreAvailable()}
                  </ButtonWrapper>
                </BasicWrapper>
              </Tab>
            </Tabs>
          </TabsWrapper>
        )}

        {this.state.termsAndConditionsModalVisible && (
          <div className="shippingSeeDetailsModal">
            <ShippingPinModal
              ariaLabel="pin modal"
              opened={this.state.termsAndConditionsModalVisible}
              onOpenedChange={this.modalChanged}
              // modalTitle={this.props.SHOP_5G_SHIPPING_MODAL_HEADING}
              modalBody={
                <>
                  <ShippingDetailsWrapper>{parse(this.props.shop_5G_SHIPPING_MODAL_CONTENT_VDS_UPG || '')}</ShippingDetailsWrapper>
                  {isMobile && (
                    <Row className="seeDetailsStyle">
                      <Button width="100%" onClick={this.closeTermsAndConditionModal}>
                        Close
                      </Button>
                    </Row>
                  )}
                </>
              }
            />
          </div>
        )}
      </>
    );
  }
}

ShippingOptions.propTypes = {
  shippingInfoDetails: PropTypes.object,
  shop_5G_SHIPPING_MODAL_CONTENT: PropTypes.string,
  selectedShippingOption: PropTypes.array,
  selectedValue: PropTypes.string,
  selectedShippingOptionValue: PropTypes.func,
  saveSelectedOption: PropTypes.func,
  cartDetails: PropTypes.object,
  defaultSelectedSlot: PropTypes.string,
  shippingOption: PropTypes.object,
  buildShippingOptionsInput: PropTypes.func,
  sddSlotsData: PropTypes.func,
  shippingAddress: PropTypes.object,
  shippingInfoState: PropTypes.object,
  notifyMessage: PropTypes.string,
  shippingHeader: PropTypes.string,
  estimatedDeliveryDate: PropTypes.any,
  openISPUModal: PropTypes.bool,
  shop_5G_SHIPPING_MODAL_CONTENT_VDS_UPG: PropTypes.string,
  fastestBadge: PropTypes.string,
  inStockText: PropTypes.string,
  milesValue: PropTypes.any,
  showErrorNotification: PropTypes.any,
  storeLists: PropTypes.array,
  changeDivToPickUp: PropTypes.func,
  updateISPUShippingOption: PropTypes.func,
  cradleResponseDetails: PropTypes.string,
  shippingDescription: PropTypes.string,
  isShippingOptionAvailable: PropTypes.bool,
  showPickupInfoTab: PropTypes.bool,
  selectOtherOption: PropTypes.bool,
  selectedExpressCheckout: PropTypes.bool,
  removedWHWPlus: PropTypes.bool,
  selectShippingData: PropTypes.array,
};
